import { Injectable, TemplateRef, signal } from '@angular/core';

/** documents attachables à un message, groupés par origine */
export type ConversationDocumentsIds = { communication: string[]; project: string[]; task: string[] };

const EMPTY_DOCUMENTS_IDS: ConversationDocumentsIds = { communication: [], project: [], task: [] };

@Injectable({
  providedIn: 'root',
})
export class CamSharedCommunicationsService {
  public taskStatusTemplate: TemplateRef<{ status: number }> | null = null;

  // signal et non objet mutable : le contexte d'une tâche peut changer après le rendu de la conversation
  private readonly _documentsIdsByTaskId = signal<{ [id: string]: ConversationDocumentsIds }>({});

  public documentsIds(taskId: string): ConversationDocumentsIds {
    return this._documentsIdsByTaskId()[taskId] ?? EMPTY_DOCUMENTS_IDS;
  }

  public setDocumentsIds(taskId: string, documentsIds: ConversationDocumentsIds) {
    this._documentsIdsByTaskId.update(current => ({ ...current, [taskId]: documentsIds }));
  }
}
